import { Link, useLocation } from 'react-router-dom'

const CREW_LINKS = [
  { href: '/learn/audio', label: 'Audio' },
  { href: '/learn/video', label: 'Video' },
  { href: '/learn/stage', label: 'Stage' },
] as const

export function CrewSubNav() {
  const { pathname } = useLocation()

  return (
    <nav className="crew-subnav" aria-label="Crew">
      <ul className="crew-subnav__list">
        {CREW_LINKS.map((l) => (
          <li key={l.href}>
            <Link
              to={l.href}
              className="crew-subnav__link"
              data-active={pathname === l.href || pathname.startsWith(l.href + '/') ? 'true' : undefined}
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}
